import axios from 'axios';
import { TAddInfoData } from '../types/ExtInfoBox';

export const getCustomerAssignedUsers = () => {
  return axios
    .get(`/api/get/assigned/users`, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const getCustomerList = (
  assigned_user: number,
  customer_name: string,
  prefecture_name: string,
  address: string,
  current_page: number,
  display_limit: number,
  rank_id: number,
  addInfoData?: TAddInfoData
) => {
  let url = `/api/get/customers/list?&assigned_user=${assigned_user}&customer_name=${customer_name}&prefecture_name=${prefecture_name}&address=${address}&page=${current_page}&display_limit=${display_limit}&rank_id=${rank_id}`;

  // 追加情報が存在する場合
  if (addInfoData) {
    const queryString = JSON.stringify(addInfoData);
    // 追加パラメーターフラグを1にする
    url = url + '&ext_info_search_flg=1&ext_info_params=' + queryString;
  } else {
    // 追加パラメーターフラグを0にする
    url = url + '&ext_info_search_flg=0';
  }

  return axios
    .get(url, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const getCustomerRank = () => {
  return axios
    .get(`/api/get/ranks`, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const deleteCustomers = (customers_list: any) => {
  return axios
    .post(
      `/api/delete/customers`,
      {
        customers_list: customers_list
      },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const getCustomerConstruction = (id: number) => {
  return axios
    .get(`/api/v1/customer/constructions/${id}`, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};
export const getExportCustomerItems = (
  selected_columns: any,
  assigned_user: number,
  customer_name: string,
  prefecture_name: string,
  address: string,
  rank_id: number,
  addInfoData?: TAddInfoData
) => {
  let url = `/api/v1/export/customers/list?&assigned_user=${assigned_user}&customer_name=${customer_name}&prefecture_name=${prefecture_name}&address=${address}&rank_id=${rank_id}`;

  // 追加情報が存在する場合
  if (addInfoData) {
    const queryString = JSON.stringify(addInfoData);
    // 追加パラメーターフラグを1にする
    url = url + '&ext_info_search_flg=1&ext_info_params=' + queryString;
  } else {
    // 追加パラメーターフラグを0にする
    url = url + '&ext_info_search_flg=0';
  }

  return axios
    .post(
      url,
      {
        selected_columns
      },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const getAllCustomerList = () => {
  return axios
    .get(`/api/get/all/customers/list`, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};
